import { createContext, useState, useEffect } from "react";

export const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
  const [loadingCount, setLoadingCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  let loadingTimeout = null;

  useEffect(() => {
    const originalFetch = window.fetch;

    window.fetch = async (...args) => {
      setLoadingCount((count) => count + 1);

      // Définir un délai avant d'afficher le loading (évite le clignotement)
      if (loadingTimeout === null) {
        loadingTimeout = setTimeout(() => {
          setIsLoading(true);
        }, 300); // ⏳ Délai de 300ms avant d'afficher le loading
      }

      try {
        const response = await originalFetch(...args);
        return response;
      } finally {
        setLoadingCount((count) => {
          const newCount = Math.max(0, count - 1);

          // Masquer le loading uniquement quand toutes les requêtes sont terminées
          if (newCount === 0) {
            clearTimeout(loadingTimeout);
            loadingTimeout = null;
            setIsLoading(false);
          }

          return newCount;
        });
      }
    };

    return () => {
      window.fetch = originalFetch; // Restaurer `fetch` original en cas de démontage
    };
  }, []);

  return (
    <LoadingContext.Provider value={{ isLoading }}>
      {children}
    </LoadingContext.Provider>
  );
};
